module.exports = __webpack_public_path__ + "static/media/1.6c706824.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/7015/1.jpg
// module id = 704
// module chunks = 0